import { Component, computed, DestroyRef, inject, OnInit, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { ActiveOrganization } from '@models/organization.model';
import { Store } from '@ngrx/store';
import { OrganizationSelectors } from '@states/organization/organization.selector-types';
import { map } from 'rxjs';
import { RunListTableComponent } from '../run-list-table/run-list-table.component';
import { UiBreadCrumbItem, UiHeaderWithBreadcrumbsComponent } from '@ui';
import { TranslateService } from '@ngx-translate/core';
import { WorkflowsSelectors } from '@states/workflow/workflow.selector-types';
import { Dictionary } from '@ngrx/entity/src';
import { WorkflowModel } from '@models/workflow.model';
import { WorkflowActions } from '@states/workflow/workflow.action.types';
import { routerSegments } from '@consts/routes';

@Component({
  selector: 'run-list-page',
  imports: [
    RunListTableComponent,
    UiHeaderWithBreadcrumbsComponent,
  ],
  templateUrl: './run-list-page.component.html',
  styleUrl: './run-list-page.component.scss'
})
export class RunListPageComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly translateService = inject(TranslateService);
  private readonly store$ = inject(Store);

  public selectOrganizationSig: Signal<ActiveOrganization> =
    this.store$.selectSignal(OrganizationSelectors.selectActiveOrganization);
  public selectWorkflowsEntities: Signal<Dictionary<WorkflowModel.WorkflowDocument>> =
    this.store$.selectSignal(WorkflowsSelectors.selectWorkflowsEntities);

  public orgIdSig: Signal<string> = computed(() => {
    const orgId = this.selectOrganizationSig().orgId as string;
    return orgId;
  })

  public graphIdSig: Signal<string> = toSignal(
    this.route.paramMap.pipe(
      map(params => params.get('graphId'))
    ),
    { initialValue: null }
  );

  public breadcrumbsSig: Signal<UiBreadCrumbItem[]> = computed(() => {
    console.log('this.selectWorkflowsEntities()', this.selectWorkflowsEntities());

    return [
      {
        name: this.translateService.instant('BREADCRUMBS.WORKFLOWS'),
        route: `/${routerSegments.workflows}`,
      },
      {
        name: this.selectWorkflowsEntities()[this.graphIdSig()]?.published?.name ?? '',
        route: `/${routerSegments.workflows}/${this.graphIdSig()}`,
      },
      { name: this.translateService.instant('FLOW_CHART.RUN_LIST_TABLE.DIALOG_TITLE') },
    ];
  })

  public ngOnInit(): void {
    //fix: update store on adding graph
    
    this.store$.dispatch(
      WorkflowActions.getWorkflows({
        orgId: this.orgIdSig(),
      }),
    );
  }
}
